<template>
  <div class="created">
    <weui-group title="您已经向私人教练提出了以下时段的课程申请" tips="稍后教练将为您做出安排">
      <weui-cell>{{ course && course.date_text }}</weui-cell>
    </weui-group>
    <weui-group>
      <weui-button-cell :to="{ name: ROUTE_COURSE_HOME }">返回课程安排</weui-button-cell>
    </weui-group>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import { WeuiGroup, WeuiCell, WeuiSwitch, WeuiButtonCell } from '@/components/weui';
import datetimeUtils from '@/utils/datetime';
import { FETCH_ONE } from '@/store/course/types';
import { ROUTE_COURSE_HOME } from '@/router/names';

const { mapState, mapActions } = createNamespacedHelpers('course');

export default {
    data() {
        return {
            ROUTE_COURSE_HOME,
        };
    },
    computed: {
        ...mapState([
            'course',
        ]),
    },
    mounted() {
        const { id } = this.$route.params;
        this.fetchCourse({
            id,
        });
    },
    methods: {
        ...mapActions({
            fetchCourse: FETCH_ONE,
        }),
        ...datetimeUtils,
    },
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiSwitch,
        WeuiButtonCell,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/course/Created.vue